import React, {Component} from 'react'

class NoticeOfPrivacy extends Component {
    render(){
        return(
            <div className="noticeOfPrivacy">
                <b>AVISO DE PRIVACIDAD.- </b>La Protección de Datos Personales es muy importante para <b><i>MARHNOS VIVIENDA, S.A.P.I. DE C.V., (“HABITAT”)</i></b>, con domicilio en Lafayette No. 40 Col. Nueva Anzures, Del. Miguel Hidalgo 11590, México D.F., datos que podrán ser usados para (1) Fines Primarios: identificarlo como cliente o representante legal; (b) elaborar documentos, contratos, convenios, facturas, recibos y documentación concerniente a la relación; (c) almacenamiento; y, (d) dar cumplimiento a términos y condiciones que hayamos establecido con usted; y (2) Fines Secundarios: (a) informarle de promociones; (b) estadística; (c) mercadeo, y (d) prospección. Para mayor información acerca del tratamiento y de los Derechos ARCO que puede hacer valer, los términos y condiciones del AVISO DE PRIVACIDAD íntegro, lo puede consultar en <a href="www.marhnoshabitat.com.mx." target="_blank">www.marhnoshabitat.com.mx.</a>. Fecha de última actualización 01/08/2013.
                <br></br>
                <b>Si usted no desea recibir más estos correos favor de notificarlo en el correo electrónico <a href="mailto:privacidadhabitat@marhnos.com.mx">privacidadhabitat@marhnos.com.mx</a></b><br></br>
            </div>
        )
    }
}

export default NoticeOfPrivacy


// WEBPACK FOOTER //
// ./src/components/NoticeOfPrivacy/NoticeOfPrivacy.js